import { Component, OnInit } from '@angular/core';
import {LoadingStateService} from "../../services/loading-state.service";
import {Observable} from "rxjs";

@Component({
  selector: 'app-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.css']
})
export class LoadingBarComponent implements OnInit {

  loadingState: Observable<boolean>;

  constructor(private loadingStateService: LoadingStateService) { }

  ngOnInit() {
    this.loadingState = this.loadingStateService.loadingState;
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/components/loading-bar/loading-bar.component.ts